export enum ParcelSource {
  VANTAGE_DRAW = 'vantageDraw',
  VANTAGE_FILE_UPLOAD = 'vantageFileUpload',
  AGRO_MAP = 'agroMap'
}
